import type { WaterProfile } from "../types";
import {
  PROFILES, eyebrow2, buyCtaLine, buyCtaLabel, trustLine, BUY_HREF, BACK_LINK,
} from "../profiles";
import { renderRich } from "./rich";
import { ProductCard } from "./ProductCard";
import { MaterialsList } from "./MaterialsList";

export function ResultPage2({
  profileKey, onBack, onCtaClick,
}: {
  profileKey: WaterProfile;
  onBack: () => void;
  /** Analytics hook fired on the buy CTA (link still opens in a new tab). */
  onCtaClick?: () => void;
}) {
  const profile = PROFILES[profileKey];
  return (
    <section className="solution">
      <button type="button" className="back" onClick={onBack}>
        {BACK_LINK}
      </button>
      <div className="sol-eyebrow reveal">{eyebrow2(profileKey)}</div>
      <h2 className="reveal">{profile.solTitle}</h2>
      <p className="bridge reveal">{renderRich(profile.bridge)}</p>

      <ProductCard profileKey={profileKey} />
      <MaterialsList profileKey={profileKey} />

      <div className="buy">
        <div className="cta-line">{buyCtaLine(profileKey)}</div>
        <a className="cta" href={BUY_HREF} target="_blank" rel="noopener noreferrer" onClick={onCtaClick}>
          {buyCtaLabel(profileKey)} →
        </a>
        <div className="trust">{trustLine(profileKey)}</div>
      </div>
    </section>
  );
}
